import axios from 'axios';

// import {URL_BASE_API } from '../configs/urlConfigs';
import {userGroupUrlCheck} from '../utils/userGroupUrlCheck';
import {LOGIN_CLIENT_GROUP} from '../configs/staticConfigs';

export const URL_BASE_API = process.env.REACT_APP_OMNI_API_URL;

let unid          = '';
let userGroupToken = '';
let affiliateId = '';
let userGroup = '';

class ApiService {    

    get(path) {    

        let userGroupData = userGroupUrlCheck(window.location);
        if(userGroupData!==undefined){
            unid              = userGroupData.unid;
            userGroupToken    = userGroupData.accessToken;
            affiliateId       = userGroupData.client_default_affiliate_id;
            userGroup         = userGroupData.user_group; 
        }    
        
        const client = axios.create({
            baseURL: URL_BASE_API,
            timeout: 60 * 10 * 1000,//Ten minutes
            headers: {
                'Content-Type': 'application/json',
                'Authorization':'Bearer '+userGroupToken,
                'unid':unid,
                ...(userGroup===LOGIN_CLIENT_GROUP && {'affiliate' : affiliateId})
            }
        });  

        return client.get(path).then(response => {
            return response;
        }).catch(error=>{
        let errorResp = {      
            status: error.response.status,
            statusText: error.response.statusText,
            data:error.response.data
        };      
        return errorResp;
        }); 
    }

    post(path,data){

        let userGroupData = userGroupUrlCheck(window.location);
        if(userGroupData!==undefined){
            unid              = userGroupData.unid;
            userGroupToken    = userGroupData.accessToken;
            affiliateId       = userGroupData.client_default_affiliate_id;
        }    
        

        const client = axios.create({
            baseURL: URL_BASE_API,
            timeout: 60 * 10 * 1000,//Ten minutes
            headers: {
                'Content-Type': 'application/json',
                'Authorization':'Bearer '+userGroupToken,
                'unid':unid,
                ...(userGroup===LOGIN_CLIENT_GROUP && {'affiliate' : affiliateId})
            }
        });  

        return client.post(path, data).then(response => {
            return response;
        }).catch(error=>{
        let errorResp = {      
            status: error.response.status,
            statusText: error.response.statusText,
            data:error.response.data
        };      
        return errorResp;
        }); 
    }

    put(path,data) {

        let userGroupData = userGroupUrlCheck(window.location);
        if(userGroupData!==undefined){
            unid              = userGroupData.unid;
            userGroupToken    = userGroupData.accessToken;
            affiliateId       = userGroupData.client_default_affiliate_id;
        }    
       
        const client = axios.create({
            baseURL: URL_BASE_API,
            timeout: 60 * 10 * 1000,//Ten minutes
            headers: {
                'Content-Type': 'application/json',
                'Authorization':'Bearer '+userGroupToken,
                'unid':unid,
                ...(userGroup===LOGIN_CLIENT_GROUP && {'affiliate' : affiliateId})
            }
        });  

        return client.put(path, data).then(response => {
            return response;
        }).catch(error=>{
        let errorResp = {      
            status: error.response.status,
            statusText: error.response.statusText,
            data:error.response.data
        };      
        return errorResp;
        }); 
    }

    delete(path) {

        let userGroupData = userGroupUrlCheck(window.location);
        if(userGroupData!==undefined){
            unid              = userGroupData.unid;
            userGroupToken    = userGroupData.accessToken;
            affiliateId       = userGroupData.client_default_affiliate_id;
        }    
       
        const client = axios.create({
            baseURL: URL_BASE_API,
            timeout: 60 * 10 * 1000,//Ten minutes
            headers: {
                'Content-Type': 'application/json',
                'Authorization':'Bearer '+userGroupToken,
                'unid':unid,
                ...(userGroup===LOGIN_CLIENT_GROUP && {'affiliate' : affiliateId})
            }
        });  

        return client.delete(path).then(response => {
            return response;
        }).catch(error=>{
        let errorResp = {      
            status: error.response.status,
            statusText: error.response.statusText,
            data:error.response.data
        };      
        return errorResp;
        }); 
    }
}

export default new ApiService()